// Phone number validation
// PhoneNumberInput always formats with +1 prefix, so we need 11 digits total (1 + 10-digit phone)
export const isValidPhoneNumber = (phone) => {
  if (!phone) return false;
  const digitsOnly = phone.replace(/\D/g, '');
  // With +1 country code, we need exactly 11 digits (1 + area code + exchange + subscriber)
  return digitsOnly.length === 11;
};

// Age calculation from date of birth
// Parses date string manually to avoid UTC/local timezone issues
export const calculateAge = (dateOfBirth) => {
  const today = new Date();
  // dateOfBirth is in format "YYYY-MM-DD" from the date input
  const [birthYear, birthMonth, birthDay] = dateOfBirth.split('-').map(Number);

  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1; // getMonth() is 0-indexed
  const currentDay = today.getDate();

  let age = currentYear - birthYear;

  // Check if birthday hasn't occurred yet this year
  if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
    age--;
  }

  return age;
};
